export const DEFAULT_COUNTRY_CODE = 'DE';

export const FLOW_IDENTIFIER_LOGGED_IN = 'JobsInstantApplyLoggedInFlow';
